import React, {useCallback, useContext} from 'react';
import {Popup, Button, setOptions} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {Listview} from '@mobiscroll/react4';
import '@mobiscroll/react4/dist/css/mobiscroll.min.css';
import '../styles/dashboardHeaderLocations.css';
import {NetworkContext} from "../utils/NetworkContext";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboardHeaderLocations({dialog, Dialog, configuration, setLocation, setRefresh, location}) {
    const {wsCall} = useContext(NetworkContext);

    const DialogClose = useCallback(() => {
        Dialog({view: 'close'});
    }, [Dialog]);

    const ButtonLocation = data => {
        setRefresh(true);
        setLocation(data);

        const message = {
            type: 'wss',
            path: 'user',
            action: 'update',
            data: {
                location: data
            }
        };
        wsCall(message);

        DialogClose();
    }

    const ListItem = data => {

        return <li key={data.item.value} className="cs-dashboard-header-locations-li">
            <Button disabled={data.item.value === location} color="primary" variant="flat" className="cs-dashboard-header-teamtalk-button mbsc-bold" onClick={() =>ButtonLocation(data.item.value)} >
                {data.item.text}
            </Button>
        </li>;
    }

  return (
      <Popup className="cs-dashboard-header-locations-popup" display="anchored" anchor={document.getElementById('dashboardHeaderLocations')} showArrow={false} buttons={[]} isOpen={dialog.view === 'dashboardHeaderLocations'} onClose={DialogClose}>
          <Listview
              theme="ios"
              themeVariant="light"
              select="single"
              itemType={ListItem}
              data={configuration.locations}
          />
      </Popup>
  );
}

export default DashboardHeaderLocations;
